export const config = {
    auth: { 
        clientId: '5f17b2e9-c976-40f2-8181-8a852182a1b6',
        redirectUri: 'https://gmedocumenthubtest.castrol.com',
        scopes: [
            'user:read'
        ],
        authority: 'https://login.microsoftonline.com/ea80952e-a476-42d4-aaf4-5457852b0f7e',
        postLogoutRedirectUri: 'https://gmedocumenthubtest.castrol.com/',
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
      }
};
